import { DatePipe }                      from '@angular/common';
import { NgModule }                      from '@angular/core';
import { AuthGuard }                     from '@app/core/guards/auth.guard';
import { DialogModalCommonComponent }    from '@app/core/modals/dialog-modal-common/dialog-modal-common.component';
import { DialogModalCommonService }      from '@app/core/modals/dialog-modal-common/dialog-modal-common.service';
import { ModalService }                  from '@app/core/modals/modal.service';
import { SelectVersionModalService }     from '@app/core/modals/select-version-modal/select-version-modal.service';
import { ShowInvalidTenantModalService } from '@app/core/modals/show-invalid-tenant/show-invalid-tenant-modal.service';
import { OpenApiCheckerService }         from '@app/core/services/open-api-checker.service';
import { SharedModule }                  from '@app/shared/shared.module';
import { APP_CONFIG }                    from '@appConfig/_app-config_master';
import { BaseComponent }                 from '@core/bases/base-component/base.component';
import { FormBaseComponent }             from '@core/bases/form-base/form-base.component';
import { FormControlBaseComponent }      from '@core/bases/form-control-base/form-control-base.component';
import { StickyBaseComponent }           from '@core/bases/sticky-base.component';
import { httpInterceptorProviders }      from '@core/interceptors';
import { SelectVersionModalModule }      from '@core/modals/select-version-modal/select-version-modal.module';
import { ShowInvalidTenantModalModule }  from '@core/modals/show-invalid-tenant/show-invalid-tenant-modal.module';
import { CurrentUserEffects }            from '@core/store/feature/current-user/effects';
import * as fromCurrentUser              from '@core/store/feature/current-user/reducer';
import * as fromUi                       from '@core/store/feature/ui/reducer';
import { routerStore }                   from '@core/store/router/router.store';
import { EffectsModule }                 from '@ngrx/effects';
import { StoreModule }                   from '@ngrx/store';
import { ListOperationsStoreModule }     from '@shared/list-operations/store/list-operations-store.module';

@NgModule( {
	declarations: [
		// Bases
		BaseComponent,
		FormBaseComponent,
		FormControlBaseComponent,
		StickyBaseComponent,

		// Modals
		DialogModalCommonComponent
	],
	imports: [
		SharedModule,

		// Modals
		SelectVersionModalModule,
		ShowInvalidTenantModalModule,

		// Router Store
		StoreModule.forFeature( routerStore.storeId, routerStore.reducers ),
		// EffectsModule.forFeature( [ RouterEffects ] ),
		// CurrentUser Store
		StoreModule.forFeature( APP_CONFIG.currentUser.store.id, fromCurrentUser.reducer ),
		EffectsModule.forFeature( [ CurrentUserEffects ] ),
		// Ui Store
		StoreModule.forFeature( APP_CONFIG.ui.store.id, fromUi.reducer ),

		ListOperationsStoreModule
	],
	providers: [
		AuthGuard,
		DatePipe,
		DialogModalCommonService,
		ModalService,
		OpenApiCheckerService,
		SelectVersionModalService,
		ShowInvalidTenantModalService,
		// TODO check what happens with Tour Feature at all
		// TourService,
		httpInterceptorProviders
	],
	exports: []
} )
export class AppCoreModule {}

